import { useRef } from 'react';
import cx from 'clsx';

import { useBodyScrollControl } from '@autopass-web/domain';
import loveCodes from '@autopass-web/domain/json/love_code.json';
import FeatureReceiptSettingDonate from '@autopass-web/feature-receipt-setting-donate';
import { ArrowLeftIcon } from '@autopass-web/mochi-icons';
import analyticsService from '@autopass-web/mochi-payment/services/analytics';

import { useAnalKey } from '../../../../hooks/analytics';
import styles from './donate.module.scss';

interface DonateListPanelProps {
  isOpen: boolean;
  loveCode: string;
  onClose: () => void;
  onLoveCodeChange: (value: string) => void;
}

export const DonateListPanel = ({
  isOpen,
  loveCode,
  onClose,
  onLoveCodeChange,
}: DonateListPanelProps) => {
  const donateListRef = useRef<HTMLDivElement>(null);

  const key = useAnalKey();

  useBodyScrollControl(donateListRef, isOpen);

  return (
    <div className={cx(styles['panel'], isOpen && styles['show'])}>
      <div className={styles['title']}>
        <ArrowLeftIcon
          onClick={() => {
            onClose();
            analyticsService.receiptDonationLeaveButtonOnClick();
          }}
        />
        選擇愛心碼
      </div>
      <FeatureReceiptSettingDonate
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        store={{
          loveCode,
          setLoveCode: onLoveCodeChange,
        }}
        isShow={isOpen}
        env={{ analyticsKey: key }}
        loveCodeList={loveCodes}
        className={styles['donateList']}
        ref={donateListRef}
      />
    </div>
  );
};
